import { authAxios } from "../api/axiosClient";
import {
  listTypeQuestionURL,
  listExamMaterialsURL,
  listOfQuestionURL,
  submitIsmsURL,
  setExamURL,
  resultISMSURL
} from "../constants";

export const getListTypeQuestionAPI = (params = {}) => {
  const url = listTypeQuestionURL;
  return authAxios().get(url, { params });
};

export const getListExamMaterialsURL = (params = {}) => {
  const url = listExamMaterialsURL;
  return authAxios().get(url, { params });
};

export const getListOfQuestionURL = (params = {}) => {
  const url = listOfQuestionURL;
  return authAxios().get(url, { params });
};

export const postSubmitIsmsURL = (params = {}) => {
  const url = submitIsmsURL;
  return authAxios().post(url, params);
};

export const getListSetExamAPI = (params = {}) => {
  const url = setExamURL;
  return authAxios().get(url, { params });
};

export const postSubmitSetExamURL = (params = {}) => {
  const url = setExamURL;
  return authAxios().post(url, params);
};

export const putSubmitSetExamURL = (params = {}) => {
  const url = setExamURL;
  return authAxios().put(url, params);
};

export const delSubmitSetExamURL = (params = {}) => {
  const url = setExamURL;
  return authAxios().delete(url, {params});
};

export const getResultISMSAPI = (params = {}) => {
  const url = resultISMSURL;
  return authAxios().get(url, { params });
};
